import { FilePanelBase, FilePanelBaseProps } from "@compass/core";
import ApiService from "services/apiService";

export const FilePanel = (props: Omit<FilePanelBaseProps, "getFile">) => {
  const { ...rest } = props;

  const getFile = async (open: boolean) => {
    if (props.fileRef && props.fileName) {
      const fileRef = props.fileRef;
      const fileName = props.fileName;

      ApiService.common.getFile(fileRef, fileName).then((response) => {
        const blob = response!.data;
        const url = window.URL.createObjectURL(blob);

        if (open) {
          window.open(url, "_blank");
        } else {
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      });
    }
  };

  return <FilePanelBase getFile={getFile} {...rest} />;
};
